import React, {Component} from "react";
import {observer, inject} from "mobx-react";
import {Modal, Button} from "antd";

@inject("dialog")
@observer
class AboutDialog extends Component {
  handleOk = () => {
    this.props.dialog.setAboutOpen(false);
  };

  handleCancel = () => {
    this.props.dialog.setAboutOpen(false);
  };

  handleVersion = () => {
    this.props.dialog.setAboutOpen(false);
    this.props.dialog.setVersionOpen(true);
  };

  render() {
    return (
      <Modal
        title="关于"
        okText="确认"
        cancelText="取消"
        visible={this.props.dialog.isAboutOpen}
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        footer={[
          <Button key="submit" type="primary" onClick={this.handleOk}>
            确认
          </Button>,
        ]}
        bodyStyle={{
          paddingTop: "5px",
        }}
      >
        <div>
          <h3 style={style.headerMargin}>Markdown 编辑器 王仕宇</h3>
          <p style={style.lineHeight}>支持自定义样式的 Markdown 开源免费编辑器</p>
          <p style={style.lineHeight}>支持微信公众号、知乎和稀土掘金</p>

          <h3 style={{...style.headerMargin, marginTop: "20px"}}>关于作者</h3>
          <p style={style.lineHeight}>
            <strong>王仕宇</strong>，一名互联网技术人，致力于在开源生态中贡献自己的力量。
          </p>
          <p style={style.lineHeight}>
            拥有自媒体账号 <strong>JavaPub</strong>，在多个社区同步更新技术内容，分享 AI 编程和 AI 知识、GitHub 开源项目。
          </p>

          <h3 style={{...style.headerMargin, marginTop: "20px"}}>个人网站</h3>
          <p style={style.lineHeight}>
            <a href="https://javapub.net.cn/" target="_blank" rel="noopener noreferrer" style={style.link}>
              JavaPub 官方网站
            </a>
          </p>
          <p style={style.lineHeight}>
            <a href="http://md.javapub.net.cn/" target="_blank" rel="noopener noreferrer" style={style.link}>
              微信 Markdown 编辑器
            </a>
          </p>
          <p style={style.lineHeight}>
            <a href="https://rodert.github.io/jsonformat/" target="_blank" rel="noopener noreferrer" style={style.link}>
              JSON 在线格式化工具
            </a>
          </p>

          <h3 style={{...style.headerMargin, marginTop: "20px"}}>社交媒体</h3>
          <p style={style.lineHeight}>
            <a href="https://github.com/Rodert" target="_blank" rel="noopener noreferrer" style={style.link}>
              GitHub
            </a>
            {" | "}
            <a href="https://www.youtube.com/@javapubnetcn" target="_blank" rel="noopener noreferrer" style={style.link}>
              YouTube
            </a>
            {" | "}
            <a href="https://www.bing.com/search?q=JavaPub" target="_blank" rel="noopener noreferrer" style={style.link}>
              搜索 JavaPub
            </a>
          </p>
          <p style={style.lineHeight}>
            抖音、小红书、B站、视频号：<strong>JavaPub</strong>
          </p>
          <p style={style.lineHeight}>
            社区平台：知乎、掘金、博客园、CSDN
          </p>
          <p style={style.lineHeight}>
            微信公众号：<strong>JavaPub</strong>（回复 1024 获取常用资源包）
          </p>
        </div>
      </Modal>
    );
  }
}

const style = {
  leftImgWidth: {
    width: "40%",
    height: "100%",
  },
  rightImgWidth: {
    width: "60%",
    height: "100%",
  },
  headerMargin: {
    marginTop: "5px",
    marginBottom: "5px",
    color: "black",
  },
  lineHeight: {
    lineHeight: "26px",
    color: "black",
    padding: 0,
    margin: 0,
  },
  img: {
    width: "70px",
    marginLeft: "10px",
    display: "inline-block",
  },
  noBorder: {
    border: "none",
  },
  link: {
    color: "#1890ff",
    textDecoration: "none",
  },
};

export default AboutDialog;
